export default {
    lang: "意大利语",
    application: {
        name: 'Sistema di pubblicazione delle informazioni',
    },
    ajaxTip: {
        success: 'Successo',
        error: 'Fallimento',
        noAccess: 'Non si dispone dell\'autorizzazione ad accedere a questa risorsa',
        notFound: 'La risorsa accessibile non esiste',
        serverBusy: 'Server occupato',
        timeOut: 'Timeout',
    },
    menu: {
        home: 'Home',
        template: 'Gestione modelli',
        program: 'Gestione programmi',
        playplan: 'Piano di riproduzione',
        device: 'Gestione dispositivi',
        "source-material": 'Gestione materiali',
        material: 'Materiali',
        checkManage: 'Gestione revisione',
        setting: 'Impostazioni',
        usercenter: "Centro utente",
        adminManage: "Gestione dispositivi",
        schedule: "Compiti da fare",
        capitalassets: "Gestione del patrimonio",
        modifyPassword: "Modifica password",
        logout: "Esci dal login",
        "add": "Aggiungi",
        "edit": "Modifica",
        "delete": "Elimina",
        "view": "Visualizza",
        "menu_1": "Home",
        "menu_2": "Gestione dispositivi",
        "menu_3": "Modifica (Impostazioni avanzate - Modifica base - Cambia rete)",
        "menu_4": "Comandi istantanei",
        "menu_5": "Modifica (Trasferisci reparto)",
        "menu_6": "Strategia",
        "menu_7": "Impostazioni volume",
        "menu_8": "Impostazioni luminosità",
        "menu_9": "Impostazioni download",
        "menu_10": "Impostazioni sospensione",
        "menu_11": "Proprietà dispositivo",
        "menu_12": "Modifica/Aggiungi",
        "menu_13": "Gestione programmi",
        "menu_14": "Cronologia pubblicazioni",
        "menu_15": "Elimina (Batch/Individuale)",
        "menu_16": "Programmi in pubblicazione",
        "menu_17": "Raggruppamento",
        "menu_19": "Elenco programmi",
        "menu_20": "Modifica contenuti",
        "menu_21": "Copia programma",
        "menu_23": "Pubblica programma",
        "menu_24": "Gestione materiali",
        "menu_25": "Carica",
        "menu_28": "Pubblicazione rapida",
        "menu_29": "Gestione modelli",
        "menu_30": "Modelli pubblici",
        "menu_31": "Usa ora",
        "menu_32": "I miei modelli",
        "menu_33": "Pubblica nei modelli pubblici",
        "menu_35": "Cronologia condivisione",
        "menu_36": "Gestione audit",
        "menu_37": "Audit programmi",
        "menu_38": "Audita (Approva/Rifiuta)",
        "menu_39": "Audit materiali",
        "menu_41": "Cronologia audit (Operatore)",
        "menu_42": "Cronologia audit (Auditore)",
        "menu_43": "Visualizza numero approvazioni",
        "menu_44": "Gestione organizzazione",
        "menu_45": "Gestione log",
        "menu_46": "Log riproduzione",
        "menu_47": "Log pubblicazioni",
        "menu_48": "Log errori",
        "menu_49": "Log operazioni",
        "menu_50": "Log file",
        "menu_51": "Log accessi",
        "menu_52": "Approvazione contenuti",
        "menu_53": "Spazio di archiviazione",
        "menu_54": "Struttura organizzativa",
        "menu_55": "Permessi di ruolo",
        "menu_56": "Autorizzazione",
        "menu_57": "Visualizza (Permessi di autorizzazione)",
        "menu_58": "Membri dell'organizzazione",
        "menu_60": "Reimposta password utenti subordinati",
        "menu_61": "Gestione attività",
        "menu_62": "Il mio saldo",
        "menu_63": "Visualizza (Dettagli fondi)",
        "menu_64": "Il mio consumo dati",
        "menu_65": "Visualizza (Dettagli consumo dati)",
        "menu_66": "Acquista consumo dati",
        "menu_67": "La mia capacità",
        "menu_68": "I miei dispositivi",
        "menu_69": "Dettagli ordine",
        "menu_70": "Visualizza (Ricarica)",
        "menu_71": "Visualizza (Modelli acquistati)",
        "menu_72": "Visualizza (Consumo dati acquistato)",
        "menu_73": "Altri permessi",
        "menu_74": "Visualizza (Statistiche materiali e programmi)",
        "menu_75": "Visualizza (Attività)",
        "menu_76": "Visualizza (Consumo dati cloud/Statistiche)",
        "menu_77": "Visualizza (Statistiche dispositivi online)"
    },
    login: {
        terminalServiceSystem: 'Sistema di servizio terminali intelligenti',
        accountLogin: 'Login account',
        register: 'Registrati',
        accountLoginTip: 'Hai già un account, accedi',
        scanQRCode: 'Scansiona il codice QR',
        readAndAgree: 'Ho letto e accetto',
        readAndAgreeLink: 'Contratto di servizio utente',
        readAndAgreeAgreement: 'Leggi e accetta il contratto di servizio utente',
        forgetpassword: "Dimenticata la password?",
        resetpassword: "Reimposta password",
        phoneEmptyTip: "Inserisci il numero di telefono",
        nextStep: "Prossimo passo",
        title: 'Benvenuto nel login',
        submit: 'Accedi',
        userName: 'Account',
        password: 'Password',
        userNameEmptyTip: 'Inserisci l\'account',
        passwordEmptyTip: 'Inserisci la password',
        passwordFormatTip: 'Inserisci il formato corretto della password',
        passwordIsOk: 'Inserisci la password di conferma',
        passwordSign: 'Inserisci la password',
        codeTip: "Inserisci il codice di verifica",
        phone: "Il numero di telefono non può essere vuoto",
        code: "Il codice di verifica non può essere vuoto",
        nickname: "Il nome dell'azienda non può essere vuoto",
        pass: "La password non può essere vuota",
        pwdMessage: "La password deve essere lunga 8~20 caratteri, non può contenere spazi e deve includere 3 dei seguenti: lettere maiuscole, lettere minuscole, numeri, caratteri speciali",
        pwdMessage01: "Inserisci una password di almeno otto caratteri con lettere e numeri",
        pwdMessage02: "La password deve essere lunga 8-20 caratteri",
        pwdMessage03: "La password non può contenere spazi",
        pwdMessage04: "La password deve includere tre dei seguenti: lettere maiuscole, lettere minuscole, numeri, simboli",
        newpassempty: "La nuova password non può essere vuota",
        newpass: "Le due password non corrispondono",
        getcode: "Ottieni codice di verifica",
        format: "Formato numero di telefono non corretto",
        chongfa: "Rinvia dopo secondi",
        isSend: 'Inviato',
        noregister: "Non hai un account? Registrati subito",
        Mobile: "Numero di telefono",
        verificationcode: "Codice di verifica",
        petname: "Nome soprannome",
        Quickregistration: "Registrazione rapida",
        xiugaimima: "Modifica password",
        jiumima: "Password vecchia",
        xinmima: "Nuova password",
        zaicishuruxinmima: "Rinserisci la nuova password",
        xiugaichenggong: "Modifica riuscita",
        xiugaishoujihao: "Modifica numero di telefono",
        dengluzhanghao: "Account di accesso",
        gongsiid: "ID azienda",
        yonghunicheng: "Nome soprannome utente",
        chuangjianshijian: "Data di creazione",
        gongsimingcheng: "Nome azienda",
        denglumima: "Password di accesso",
        jianyi: "Si consiglia di utilizzare una password combinata di lettere e numeri",
        shezhimima: "Imposta password",
        shezhishoujihao: "Modifica/Imposta numero di telefono",
        yibangding: "Già associato",
        weibangding: "Non associato",
        zhanghuanquan: "Sicurezza account",
        yonghuxinxi: "Informazioni utente",
        zhuceSucMsg: 'Congratulazioni, registrazione riuscita!',
        verificationcodeSucMsg: "Invio codice di verifica riuscito！",
        requiredIsEmpty: "I campi obbligatori non possono essere vuoti！",
        emailObj: {
            title: 'Email',
            tit: 'Login email',
            tip: 'Inserisci l\'indirizzo email',
            formatTip: 'Inserisci un formato di email corretto',
        },
        phoneObj: {
            title: 'Numero di telefono',
            tit: 'Login telefono',
            tip: 'Inserisci il numero di telefono',
            formatTip: 'Inserisci un formato di numero di telefono corretto',
        },
        emailOrPhoneObj: {
            title: 'Email o numero di telefono',
            tit: 'Login email o telefono',
            tip: 'Inserisci email o numero di telefono',
            formatTip: 'Inserisci un formato corretto di email o numero di telefono',
        },
        wechatObj: {
            title: 'WeChat',
            tit: 'Login WeChat',
        },
        googleObj: {
            title: 'Google',
            tit: 'Login Google',
        },
        confirm: 'Conferma',
        confirmSubmit: 'Invia conferma',
        cancel: 'Annulla',
        close: 'Chiudi',
        bindSucMsg: 'Associazione riuscita',
        toContinueBindAccount: 'Continua per completare l\'associazione dell\'account di terze parti',
        bindTip01: 'Non hai un account? Crea uno',
        bindTip02: 'Hai già un account',
        bindTip03: 'L\'account di terze parti corrente non è associato a un account della piattaforma. Associa un account esistente o registra e associa un nuovo account per accedere rapidamente la prossima volta.',
        bindTip04: 'Associa account esistente',
        bindTip05: 'Registra e associa nuovo account',
        bindTip06: 'Ti sei autorizzato tramite terze parti, completa le seguenti informazioni di accesso per finalizzare l\'associazione',
        bindSubmit: 'Invia associazione',
        enterAccountTip: 'Inserisci il nome dell\'account',
        RegisterAndBind: 'Registra e associa',
        loginErr: 'Nome utente o password errati！',
        usercenter: "Centro utente",
        pleaseInputName: "Inserisci il nome",
        operationSuccess: "Operazione riuscita！",
        edit: "Modifica",
        xiugai: "Modifica",
        userData: "Dati personali",
        changePassword: "Modifica password",
        account: "Account",
        userName01: "Nome utente",
        phoneNumber: "Numero di telefono",
        role: "Ruolo",
        createTime: "Data di creazione",
        genghuang: "Sostituisci",
        bangding: "Associa",
        unbind: "Disassocia",
        plesaseSelectBindingType: "Seleziona il tipo di associazione",
        pleaseConfirmCont: "Conferma di aver letto questo contenuto",
        confirmReadCont: "Ho letto questo contenuto",
        frequentTip: "Operazione troppo frequente, riprova più tardi!",
        zhuxiaoBtn: "Cancella account",
        zhuxiaoTitle: "Cancellazione account",
        querenZhuxiao: "Conferma cancellazione",
        jiXu: "Continua",
        sendCodeBtn: "Invia codice di verifica",
        passwordIsNotOldPassword: "La password di conferma è diversa da quella nuova inserita",
        passwordIsOldPassword: "La password modificata è uguale a quella originale",
        passFormatError: "Inserisci il formato corretto della password",
        oldPassWord: "Password originale",
        newPassWord: "Nuova password",
        inputPlaceholder: 'Inserisci',
        confirmPassword: "Conferma password",
        zhuxiaoTip: `
            1、La cancellazione dell'account è un'operazione irreversibile. Una volta cancellato l'account, non potrai più accedere e utilizzare questo account o gli account di terze parti registrati/accessi tramite questo account. Fai un backup autonomo delle informazioni e dei dati relativi all'account.
            2、Prima della registrazione di questo account, assicurati di aver svuotato tutti i beni e che non vi siano controversie; una volta cancellato questo account, si considera che rinunci alla proprietà di tutti i beni e diritti all'interno di questo account, e non possono essere recuperati o ritrovati.
            3、Se un numero di telefono registra account cancellati per un totale di 3 volte, quel numero di telefono non potrà più registrare nuovi account e non potrà essere associato ad alcun altro account.
        `
    },
    home: {
        title: "Home",
        quickOperation: "Operazioni rapide",
        addDevice: "Aggiungi dispositivo",
        publishProgram: "Pubblica programma",
        publishMaterial: "Pubblica materiale",
        makeProgram: "Crea programma",
        uploadMaterial: "Carica materiale",
        todayData: "Dati di oggi (aggiornati ogni ora)",
        playNumChart: "Statistiche numero riproduzioni",
        deviceOnlineStatus: "Stato connessione dispositivi",
        onLineDevice: "Dispositivi online",
        unLineDevice: "Dispositivi offline",
        programPlayTime: "Statistiche durata riproduzione programmi",
        downloadSoft: "Download software",
        adminApp: "App utente mobile",
        playerApp: "Terminale riproduzione pubblicazione informazioni",
        downloadAdminApp: "Clicca per scaricare l'app utente",
        downloadPlayerApp: "Clicca per scaricare l'app riproduttore",
        aboutUs: "Chi siamo",
        userManual: "Manuale utente",
        message: "Lascia un messaggio",
    },
    device: {
        inputPlaceholder: 'Inserisci',
        selectPlaceholder: 'Seleziona',
        osTypeStr: 'Sistema terminale',
        onLineStatus: 'Stato connessione',
        dpi: 'Risoluzione',
        companyDeptIdName: 'Organizzazione di appartenenza',
        deviceGroupIdName: 'Gruppo di appartenenza',
        editOrMove: 'Modifica/Sposta',
        loanOriginationFee: 'Commissione prestito',
        strategyInfoLook: 'Visualizza informazioni strategia',
        programLook: 'Visualizza programmi',
        addEquipments: 'Aggiungi dispositivi',
        luminanceSet: 'Controllo luminosità',
        terminal: 'Impostazioni terminale',
        transferCompany: 'Trasferisci reparto',
        releasedProgram: 'Pubblica programma',
        screenshot: 'Screenshot',
        changeGroup: 'Cambia gruppo',
        defaultGroup: "Gruppo predefinito",
        operation: "Operazioni",
        edit: "Modifica",
        saveEdit: "Salva modifiche",
        add: "Aggiungi",
        save: "Salva",
        setting: "Impostazioni",
        program: "Programmi",
        unbind: "Disassocia",
        sleep: "Sospendi",
        wakeup: "Attiva",
        restart: "Riavvia",
        shutdown: "Spegni",
        reportLog: "Invia log",
        clearPlayData: "Pulisci dati terminale riproduzione",
        offlineWarn: "Il dispositivo è offline, riprova quando sarà online！",
        confirmUnbind: "Conferma disassociazione",
        confirmReset: "Conferma pulizia",
        confirmDelete: "Conferma eliminazione",
        delete: "Elimina",
        cancelDelete: "Annulla eliminazione",
        confirmResetSuccess: "Pulizia riuscita",
        confirm: "Conferma",
        cancel: "Annulla",
        operationSuccess: "Operazione riuscita",
        unbindSuccess: "Disassociazione riuscita",
        pleaseSelectDevice: "Seleziona un dispositivo",
        pleaseSelectOnlineDevice: "Seleziona un dispositivo online",
        confirmMixOperation: "I dispositivi selezionati includono dispositivi offline, l'impostazione non avrà effetto su di essi, confermi di continuare l'operazione？",
        pleaseSelectDate: "Seleziona una data",
        reportSuccess: "Invio riuscito",
        deviceSetting: "Impostazioni dispositivo",
        default: "Predefinito",
        all: "Tutti",
        deviceList: "Elenco dispositivi",
        addDevice: "Aggiungi dispositivo",
        department: "Organizzazione reparti",
        deviceType: "Risoluzione",
        osType: "Sistema terminale",
        onlineState: "Stato connessione",
        online: "Online",
        offline: "Offline",
        notActive: "Non attivato",
        search: "Inserisci parola chiave",
        batchOperation: "Operazioni batch",
        allDevices: "Tutti i dispositivi",
        deviceAttribute: "Attributi dispositivo",
        selectReportDate: "Seleziona data invio",
        inputName: "Inserisci nome",
        inputWidth: "Inserisci larghezza",
        inputHeight: "Inserisci altezza",
        inputResolutionRatio: "Inserisci un intero maggiore di 0！",
        inputSort: "Inserisci ordinamento",
        serialNum: "Numero di serie",
        name: "Nome",
        width: "Larghezza",
        height: "Altezza",
        resolutionRatio: "Risoluzione",
        inputResolutionRatioName: "Inserisci nome risoluzione",
        sort: "Ordinamento",
        personal: "Personale",
        system: "Sistema",
        type: "Tipo",
        systemDefaultSettingUneditable: "Le impostazioni predefinite del sistema non sono modificabili!",
        systemDefaultSettingUnDeletable: "Le impostazioni predefinite del sistema non sono eliminabili!",
        newz: "Nuovo",
        total: "Totale",
        totalNum: "elementi",
        strategyName: "Nome strategia",
        associatedTerminalNum: "Numero terminali associati",
        createTime: "Data di creazione",
        pleaseSelectStrategy: "Seleziona una strategia！",
        onlySelectOneData: "È possibile selezionare solo un dato！",
        downloadStrategy: "Scarica strategia",
        inputStrategyName: "Inserisci nome strategia",
        luminanceControl: "Controllo luminosità",
        volumeStrategy: "Strategia volume",
        saveSuccess: "Salvataggio riuscito",
        screenAngle: "Rotazione schermo(°)",
        startTime: "Orario inizio",
        endTime: "Orario fine",
        repeat: "Ripeti",
        monday: "Lunedì",
        tuesday: "Martedì",
        wednesday: "Mercoledì",
        thursday: "Giovedì",
        friday: "Venerdì",
        saturday: "Sabato",
        sunday: "Domenica",
        everyday: "Ogni giorno",
        downloadSpeed: "Velocità download",
        inputDownloadSpeed: "Inserisci velocità download",
        operator: "Operazioni",
        pleaseSelectDeleteData: "Seleziona i dati da eliminare！",
        confirmBatchDelete: "Confermi l'eliminazione batch？",
        pleaseInputName: "Inserisci il nome",
        detailSetting: "Impostazioni dettagliate",
        weekPlan: "Piano settimanale",
        specialDateSetting: "Impostazioni date speciali",
        weekdayInfo: "Il giorno della settimana è obbligatorio!",
        volumeInfo: "Il volume è obbligatorio!",
        timeError: "Errore nella selezione dell'orario!",
        editSuccess: "Modifica riuscita！",
        addSuccess: "Aggiunta riuscita！",
        addSpecialPlan: "Aggiungi piano strategico speciale",
        downloadSpeedInfo: "Velocità download:(0 indica download vietato)",
        pleaseSelectStartTime: "Seleziona orario inizio",
        pleaseSelectEndTime: "Seleziona orario fine",
        luminanceError: "Inserisci un valore di luminosità corretto！",
        defaultLuminance: "Luminosità predefinita",
        luminance: "Livello luminosità",
        defaultLuminanceInfo: "Luminosità predefinita(100 indica massima luminosità, 0 indica buio totale)",
        volume: "Volume",
        saveLuminance: "Salva luminosità",
        changeSuccess: "Modifica riuscita！",
        changeNetwork: "Cambia rete",
        netName: "Nome rete",
        nameempty: "Il nome della rete non può essere vuoto",
        currentNetwork: "Rete corrente",
        ipAddress: "Indirizzo IP",
        dailyMode: "Modalità giornaliera",
        weeklyMode: "Modalità settimanale",
        turnOnTime: "Orario accensione",
        turnOffTime: "Orario spegnimento",
        startSleep: "Inizio sospensione",
        endSleep: "Fine sospensione",
        batchDelInfo: "Confermi l'eliminazione degli elementi selezionati？",
        timeCannotBeEmpty: "L'orario non può essere vuoto!",
        startUp: "Accendi",
        shutDown: "Spegni",
        volumeSize: "Livello volume",
        defaultVolume: "Volume predefinito(100 indica massimo volume, 0 indica silenzio)",
        chooseStartTime: "Seleziona orario inizio",
        chooseEndTime: "Seleziona orario fine",
        saveVolume: "Salva volume",
        screenRotationUnSaved: "Rotazione schermo non salvata",
        volumeSettingUnSaved: "Impostazioni volume non salvate",
        luminanceSettingUnSaved: "Impostazioni luminosità non salvate",
        confirmClosePopup: "Confermi la chiusura di questa finestra popup?",
        volumeSettingSuccess: "Modifica volume riuscita",
        luminanceSettingSuccess: "Modifica luminosità riuscita",
        advancedSettingUnSaved: "Impostazioni avanzate non salvate",
        settingTitle: "Impostazioni terminale",
        volumeSetting: "Impostazioni volume",
        luminanceSetting: "Impostazioni luminosità",
        downloadSetting: "Impostazioni download",
        sleepSetting: "Impostazioni sospensione",
        onOffSetting: "Accensione/spegnimento programmato",
        screenRotation: "Rotazione schermo",
        namingError: "Errore di denominazione, il nome del file non può contenere spazi！",
        deleteSuccess: "Eliminazione riuscita",
        deleteFolder: "Elimina cartella",
        pleaseInputDeviceName: "Inserisci nome dispositivo",
        pleaseInputDeviceId: "Inserisci ID dispositivo",
        discoverDevice: "Scopri dispositivo",
        deviceId: "ID dispositivo",
        bound: "Già associato",
        bind: "Associa",
        noDevice: "Nessun dispositivo",
        refresh: "Aggiorna",
        manualAdd: "Aggiungi manualmente",
        deviceGroup: "Categoria dispositivi",
        pleaseSelectGroup: "Seleziona un gruppo！",
        deviceName: "Nome dispositivo",
        goAdd: "Vai all'aggiunta",
        close: "Chiudi",
        bindCountInsufficient: "Numero di associazioni disponibili insufficiente, aggiorna il numero di dispositivi prima di aggiungerne di nuovi！",
        displayNumber: "Numero visualizzazione",
        groupName: "Nome gruppo",
        pleaseSelectGroupName: "Inserisci il nome del gruppo！",
        moveGroup: "Sposta gruppo",
        longitude: "Longitudine",
        latitude: "Latitudine",
        nationality: "Nazionalità",
        province: "Provincia",
        city: "Città",
        county: "Contea",
        outNetIp: "IP rete esterna",
        inNetIp: "IP rete interna",
        companyName: "Nome azienda",
        Info: "Dettagli",
        android: "Android",
        win: "Windows",
        osVersion: "Versione sistema",
        softwareVersion: "Versione software",
        diskSize: "Dimensione disco",
        useSize: "Spazio utilizzato",
        macAddr: "Indirizzo MAC",
        longitudeLatitudeInfo: "Longitudine e latitudine devono essere entrambe vuote o entrambe compilate!",
        terminalName: "Nome terminale",
        terminalGroup: "Gruppo terminali",
        reportJournal: "Invio log",
        systemVersion: "Versione sistema",
        storageSpace: "Spazio di archiviazione",
        resolution: "Risoluzione",
        runningMemory: "Memoria operativa",
        model: "Modello",
        registerStatus: "Stato registrazione",
        password: "Password",
        passwordInfo: "Inserisci 6-18 lettere o numeri!",
        group: "Gruppo",
        address: "Indirizzo",
        remark: "Nota",
        renewalPeriod: "Periodo rinnovo",
        money: "Costo",
        latitudeInfo: "Inserisci una latitudine corretta!",
        totalPayment: "Importo totale",
        longitudeInfo: "Inserisci una longitudine corretta!",
        setMeal: "Pacchetto",
        number: "Quantità",
        programName: "Nome programma",
        playStatus: "Stato riproduzione",
        playType: "Modalità riproduzione",
        play: "Riproduci",
        pause: "Pausa",
        playTime: "Orario riproduzione",
        programDeleted: "Programma eliminato",
        playSuccess: "Programma programmato per la riproduzione",
        pauseSuccess: "Pausa riuscita",
        playCycle: "Riproduzione ciclica",
        playInsert: "Inserimento riproduzione",
        withdrawSuccess: "Revoca riuscita",
        withdrawInfo: "Seleziona prima il programma da revocare！",
        programBelong: "Programma di appartenenza",
        checkAll: "Seleziona tutto",
        batchDel: "Eliminazione batch",
        delConfirm: "Confermi l'eliminazione degli elementi selezionati？",
        check: "Selezionato",
        noProgram: "Nessun programma",
        details: "Dettagli",
        screenshotFail: "Screenshot fallito",
        policyName: "Nome politica",
        terminalNum: "Numero terminali associati",
        powerStrategy: "Strategia alimentazione",
        pleaseSelectDepartment: "Seleziona un reparto！",
        screenshotControl: "Controllo screenshot",
        未激活: "Non attivato",
        已激活: "Attivato",
        未绑定: "Non associato",
        已绑定: "Associato",
    },
    programManage: {
        programList: "Elenco programmi",
        publishProgram: "Tracciabilità pubblicazione programmi",
        week1: "Lunedì",
        week2: "Martedì",
        week3: "Mercoledì",
        week4: "Giovedì",
        week5: "Venerdì",
        week6: "Sabato",
        week7: "Domenica",
        monday: "Lunedì",
        tuesday: "Martedì",
        wednesday: "Mercoledì",
        thursday: "Giovedì",
        friday: "Venerdì",
        saturday: "Sabato",
        sunday: "Domenica",
        name: "Nome",
        preview: "Anteprima",
        playDeviceNum: "Numero dispositivi riproduzione",
        copyDeviceCode: "Clicca per copiare",
        osType: "Tipo sistema",
        playDate: "Data riproduzione",
        playWeek: "Settimana riproduzione",
        everyday: "Ogni giorno",
        start: "Da",
        end: "A",
        playOperateStatusStr: "Stato pubblicazione",
        playDevice: "Dispositivi riproduzione",
        downloadView: "Scarica e visualizza",
        publisher: "Autore pubblicazione",
        publishTime: "Orario pubblicazione",
        operation: "Operazioni",
        add: "Aggiungi",
        groupName: "Nome gruppo",
        selectDevice: "Seleziona terminale",
        searchDevice: "Cerca terminale",
        pleaseFillGroupName: "Inserisci il nome del gruppo！",
        remarkInfo: "Nota",
        compile: "Modifica",
        withdrawConfirm: "Confermi la revoca di questo programma？",
        confirm: "Conferma",
        cancel: "Annulla",
        withdraw: "Revoca",
        batchWithdraw: "Revoca batch",
        batchPublish: "Pubblicazione batch",
        batchDelete: "Eliminazione batch",
        batchOperation: "Operazioni batch",
        notUse: "Non utilizzato",
        notChecked: "Non revisionato",
        notPass: "Non approvato",
        delete: "Elimina",
        publishTextLeft: "Già pubblicato",
        offTextLeft: "Già sospeso",
        pleaseSelectProgramToMove: "Seleziona il programma da trasferire！",
        pause: "Pausa",
        pauseConfirm: "Confermi la pausa？",
        play: "Riproduci",
        downloadUdisk: "Scarica su USB",
        deviceList: "Elenco dispositivi",
        groupSelection: "Selezione gruppo",
        operationSuccess: "Operazione riuscita",
        deleteSuccess: "Eliminazione riuscita",
        selectDate: "Seleziona data",
        publishStatus: "Stato pubblicazione",
        checkStatus: "Stato revisione",
        waitAuditing: "In attesa di revisione",
        auditPass: "Revisione superata",
        auditRefuse: "Revisione rifiutata",
        all: "Tutti",
        playStatus: "In riproduzione",
        playStatust: "Stato riproduzione",
        pauseStatus: "Sospeso",
        notStartStatus: "Non iniziato",
        resolutionratio: "Risoluzione",
        totalNum: "elementi",
        programName: "Nome programma",
        playStartTime: "Orario inizio riproduzione",
        playEndTime: "Orario fine riproduzione",
        createTime: "Data di creazione",
        nationality: "Nazionalità",
        province: "Provincia",
        city: "Città",
        county: "Provincia/distretto",
        address: "Indirizzo",
        ip: "Indirizzo IP",
        location: "Posizione",
        log: "Log",
        pleaseFillProgramName: "Inserisci il nome del programma！",
        selectGroup: "Seleziona gruppo",
        startTime: "Orario inizio",
        endTime: "Orario fine",
        publishCycle: "Ciclo pubblicazione",
        publishDeviceNum: "Numero dispositivi pubblicazione",
        pleaseSelectRecord: "Seleziona un record",
        deviceName: "Nome terminale",
        deviceId: "ID dispositivo terminale",
        deviceGroupIdName: "Gruppo di appartenenza",
        notClassified: "Non classificato",
        osTypeStr: "Sistema terminale",
        storageSpace: "Spazio di archiviazione",
        onLineStatus: "Stato connessione",
        onLine: "Online",
        offLine: "Offline",
        sleep: "Sospeso",
        unknown: "Sconosciuto",
        registerStatus: "Stato registrazione",
        trialPeriod: "Periodo di prova",
        notActive: "Non attivato",
        active: "Attivato",
        parameterError: "Parametri errati!",
        pleaseSelectProgram: "Seleziona un programma!",
        pleaseSelectProgramEdit: "Seleziona il programma da modificare!",
        confirmWithdrawSelectedProgram: "Confermi la revoca dei programmi selezionati？",
        withdrawSuccess: "Revoca riuscita",
        allPrograms: "Tutti i programmi",
        defaultGroup: "Gruppo predefinito",
        cannotShareEmptyProgram: "Impossibile condividere un programma vuoto！",
        onlyShareYourProgram: "Puoi condividere solo i programmi creati da te!",
        pleaseSelectProgramEditPublishTime: "Seleziona il programma con l'orario di pubblicazione modificato!",
        pleaseSelectDevice: "Seleziona un dispositivo!",
        programDetail: "Dettagli programma",
        errorReason: "Motivo errore",
        availableStorageSpaceInsufficient: "Spazio di archiviazione disponibile insufficiente",
        partialDeviceReleaseFailure: "Pubblicazione fallita su alcuni dispositivi",
        allDeviceReleaseSuccess: "Pubblicazione riuscita su tutti i dispositivi",
        partialDeviceReleaseSuccess: "Pubblicazione riuscita su alcuni dispositivi",
        allGroup: "Tutti i gruppi",
        allProgram: "Tutti i programmi",
        unGrouped: "Non raggruppato",
        replaceProgram: "Sostituisci programma",
        replaceProgramTip: "Il nuovo programma pubblicato sostituirà i dati dei programmi precedentemente inviati al terminale di riproduzione！",
        screen: "Schermo singolo/doppio",
        singleScreen: "Schermo singolo",
        doubleScreen: "Schermo doppio",
        playSetting: "Impostazioni riproduzione",
        batchPlaySetting: "Impostazione batch orario riproduzione",
        individualPlaySetting: "Impostazione individuale orario riproduzione",
        playTime: "Orario riproduzione",
        daily: "Ogni giorno",
        weekdays: "Da lunedì a venerdì",
        monthly: "Mese corrente",
        advancedSetting: "Impostazioni avanzate",
        playProgram: "Riproduci programma",
        searchProgram: "Inserisci parola chiave",
        shareAddressNotExist: "Indirizzo condivisione non esistente, riprova",
        copySuccess: "Copia riuscita",
        shareLink: "Link condivisione",
        publish: "Pubblica",
        noResource: "Nessuna risorsa",
        single: "Schermo singolo",
        double: "Schermo doppio",
        time: "Orario",
        associatedTerminalNum: "Numero terminali associati",
        default: "Predefinito",
        moveGroup: "Sposta gruppo",
        pleaseSelectGroup: "Inserisci il nome del gruppo！",
        copy: "Copia",
        FUBEN: "Copia",
        nameempty: "Il nome non può essere vuoto",
        whitespace: "Errore di denominazione, il nome del file non può contenere spazi！",
        programWhitespace: "Errore di denominazione, il nome del programma non può contenere spazi！",
        pleaseSelectResolution: "Seleziona una risoluzione！",
        dataError: "Dati errati！",
        createProgram: "Crea nuovo programma",
        directCreate: "Crea direttamente",
        myTemplate: "I miei modelli",
        use: "Usa",
        free: "Gratuito",
        loadMore: "Carica altro",
        confirmDelete: "Conferma eliminazione",
        deleteGroup: "Elimina gruppo",
        notPublished: "Non pubblicato",
        notPassed: "Non approvato",
        notUsed: "Non utilizzato",
        confirmDeleteSelectedProgram: "Confermi l'eliminazione dei programmi selezionati？",
        companyName: "Nome azienda",
        programCannotDownload: "Questo programma non può essere scaricato！",
        publishMaterial: "Pubblica materiale",
        playMaterial: "Riproduci materiale",
        pleaseInputMaterialName: "Inserisci nome materiale",
        size: "Dimensione",
        pleaseInputDeviceName: "Inserisci nome dispositivo",
        item: "elementi",
        allMaterial: "Tutti i materiali",
        allDevices: "Tutti i dispositivi",
        "saveSuccess": "Salvato con successo",
        "savefaill": "Salvataggio fallito",
        "playMode": "Modalità di riproduzione",
        "cyclePlay": "Riproduzione ciclica",
        "insertPlay": "Riproduzione inserita",
        "noData": "Nessun dato disponibile",
        "Add": "Aggiungi",
        "replace": "Sostituisci",
        "repeat": "Ripeti",
        "start01": "Inizio",
        "end01": "Fine",
        "startDate": "Data di inizio",
        "endDate": "Data di fine",
        "useNow": "Usa subito",
        "fillStartEndTimeFirst": "Completa prima l'ora di inizio e fine prima di aggiungere",
        "fillFullPlayTime": "Completa la durata di riproduzione completa",
        "fillCorrectPlayTime": "Completa il periodo di riproduzione corretto",
        "sDateAndEDateBothEmptyOrFilled": "La data di inizio e la data di fine devono essere entrambe vuote o entrambe compilate"
    },
    source: {
        addResource: "Aggiungi risorsa",
        width: "Larghezza",
        height: "Altezza",
        size: "Dimensione(KB)",
        name: "Nome",
        pleaseInputResourceName: "Inserisci il nome della risorsa！",
        addToGroup: "Aggiungi al gruppo",
        remark: "Nota",
        promptFgIllustrate: "Illustrazione",
        promptFgRealisticPhoto: "Foto realistica",
        promptFgSimplisticDrawing: "Disegno semplice",
        promptFgChineseStyle: "Stile cinese",
        promptFgPixelArt: "Pixel art",
        noModel: "Nessun modello disponibile, contatta l'amministratore！",
        getModelFailed: "Recupero modello fallito, riprova più tardi！Oppure contatta l'amministratore！",
        createImagePrompt: "Generazione immagine in corso, chiudi più tardi！",
        promptEmpty: "Inserisci il prompt",
        dpiEmpty: "Seleziona il rapporto immagine！",
        fgEmpty: "Seleziona lo stile！",
        style: "Stile",
        idEmpty: "L'ID immagine non può essere vuoto",
        exist: "L'immagine è già presente nei materiali",
        addSuccess: "Aggiunta materiale riuscita",
        saveError: "Salvataggio immagine fallito, riprova più tardi！",
        delSuccess: "Eliminazione riuscita",
        generateImage: "Testo in immagine",
        generateImagePlaceholder: 'Inserisci l\'immagine che vuoi generare, es: una farfalla che danza tra i fiori',
        aiExpand: "Espansione intelligente AI",
        negativePrompt: "Prompt negativo",
        negativePromptTooltip: "Usato per escludere chiaramente contenuti o caratteristiche che l'utente non desidera nell'output",
        imageRatio: "Rapporto immagine",
        generateImageBtn: "Genera subito",
        shengchengjieguo: "Risultato generazione",
        generateImageLoadingTip: "Generazione in corso, non cliccare ripetutamente o chiudere...",
        Tooltip: "Da libero sfogo alla tua creatività con l'AI",
        saveToMaterial: "Salva nei materiali",
        publish: "Pubblica subito",
        download: "Scarica",
        generateHistory: "Cronologia generazioni",
        hide: "Riduci",
        cancel: "Annulla",
        useExpand: "Usa espansione",
        all: "Tutti",
        delete: "Elimina",
        loadMore: "Carica altro",
        aiTip: "Il contenuto è generato da modelli di intelligenza artificiale e non rappresenta il punto di vista, la posizione o l'attitudine della piattaforma. Utilizza il contenuto AI in modo legale e conforme alle normative",
        operationSuccess: "Operazione riuscita",
        moveGroup: "Sposta gruppo",
        groupName: "Nome gruppo",
        pleaseSelectGroup: "Seleziona il nome del gruppo！",
        shenhe: "Revisione",
        shenheStatus: "Stato revisione",
        shenheSuccess: "Revisione superata",
        shenheRefuse: "Revisione rifiutata",
        pleaseSelectShenheStatus: "Seleziona lo stato di revisione！",
        shenheRemark: "Nota revisione",
        pleaseInputShenheRemark: "Inserisci la nota di revisione！",
        pleaseInputFileName: "Inserisci il nome del file！",
        whitespace: "Errore di denominazione, il nome del file non può contenere spazi！",
        dataError: "Dati errati！",
        confirmDelete: "Conferma eliminazione",
        confirm: "Conferma",
        deleteFolder: "Elimina cartella",
        add: "Aggiungi",
        edit: "Modifica",
        fileName: "Nome file",
        group: "Gruppo",
        resolution: "Risoluzione",
        type: "Tipo",
        image: "Immagine",
        music: "Musica",
        video: "Video",
        uploadTime: "Orario caricamento",
        uploadUser: "Utente caricamento",
        checkTime: "Orario revisione",
        checkUser: "Utente revisione",
    },
    setting: {
        nameempty: "Il nome non può essere vuoto",
        heightempty: "L'altezza non può essere vuota",
        widthempty: "La larghezza non può essere vuota",
        resolutionratio: "Risoluzione",
        name: "Nome",
        opteration: "Operazioni",
        compile: "Modifica",
        delete: "Elimina",
        newz: "Nuovo",
        compileratio: "Modifica risoluzione",
        sheizhifenbianlvmingcheng: "Imposta nome risoluzione",
        shezhigaodu: "Imposta altezza",
        shezhikuandu: "Imposta larghezza",
        xinzengfenbianlv: "Nuova risoluzione",
        bianma: "Codifica",
        bianjizhongduanmingcheng: "Modifica nome terminale",
        xinzengzhongduan: "Nuovo terminale",
        selectPrimaryColor: 'Seleziona colore tema',
        fullScreen: 'Schermo intero',
        exitFullScreen: 'Esci da schermo intero',
    },
    tabs: {
        refresh: 'Aggiorna',
        refreshAll: 'Aggiorna tutto',
        close: 'Chiudi',
        closeOthers: 'Chiudi altri',
        closeAll: 'Chiudi tutti',
        closeLeft: 'Chiudi a sinistra',
        closeRight: 'Chiudi a destra',
    },
    errorPage: {
        needLogin: 'Non sei ancora loggato！',
        pageNotFound: 'La pagina a cui stai accedendo non esiste！',
        redirectTo: 'Reindirizza a',
        orReturn: 'Oppure torna a',
        previousStep: 'Passo precedente',
    },
    headerUs: {
        systemNotice: "Notifiche sistema",
        allNotices: "Tutte le notifiche",
        viewAllMessages: "Visualizza tutti i messaggi",
        contactUs: "Contattaci",
        operationSuccess: "Operazione riuscita！",
        leaveMessage: "Lascia un messaggio",
        messageTitle: "Titolo",
        messageTitleTip: "Inserisci il titolo！",
        messageContentTip: "Max 150 caratteri",
        submit: "Invia",
        markAsRead: "Marca come letto",
        success: "Operazione riuscita！"
    },
    material: {
        allMaterial: "Tutti i materiali",
        defaultGroup: "Gruppo predefinito",
        auditStatus: "Stato revisione",
        auditPassed: "Revisione superata",
        auditRejected: "Revisione rifiutata",
        pendingAudit: "In attesa di revisione",
        all: "Tutti",
        operateSuccess: "Operazione riuscita！",
        pleaseSelectMaterial: "Seleziona un materiale！",
        moveGroup: "Sposta gruppo",
        pleaseSelectGroup: "Seleziona un gruppo！",
        batchPublish: "Pubblicazione batch",
        batchRecall: "Revoca batch",
        batchDelete: "Eliminazione batch",
        materialList: "Elenco materiali",
        uploadMaterial: "Carica materiale",
        materialType: "Tipo materiale",
        pleaseInputMaterialName: "Inserisci nome materiale",
        selectAll: "Seleziona tutto",
        confirmDeleteSelectedMaterial: "Confermi l'eliminazione dei materiali selezionati？",
        deleteSuccess: "Eliminazione riuscita",
        delete: "Elimina",
        publish: "Pubblica",
        recall: "Revoca",
        confirmRecallSelectedMaterial: "Confermi la revoca dei materiali selezionati？",
        pleaseSelectMaterialGroup: "Seleziona il gruppo di materiali！",
        recallSuccess: "Revoca riuscita",
        publishSuccess: "Pubblicazione riuscita",
        batchOperate: "Operazioni batch",
        item: "elementi",
        confirmDelete: "Confermi l'eliminazione？",
        edit: "Modifica",
        confirmRecall: "Confermi la revoca？",
        unaudited: "Non revisionato",
        notPassed: "Non approvato",
        operate: "Operazioni",
        resolution: "Risoluzione",
        none: "Nessuno",
        confirm: 'Conferma',
        cancel: 'Annulla',
        AICreation: "Creazione AI",
    },
    uploadFile: {
        operationSuccess: "Operazione riuscita",
        uploadFile: "Gestione caricamenti",
        uploadSuccess: "Caricamento riuscito",
        uploadCompleted: "Caricamento completato",
        uploadFail: "Caricamento fallito",
        ConversionFailed: "Conversione fallita！",
        loading: "Caricamento in corso...",
        beQueuing: "In coda...",
        Uploading: "Caricamento in corso...",
        ConversionIng: "Conversione in corso...",
        ConventionalResources: "Risorse convenzionali",
        DocumentResources: "Risorse documentali",
        complete: "Completato",
        upload: "Carica",
        fileSizeWraning01: "La dimensione del materiale supera",
        fileSizeWraning02: "Modifica e ricarica！",
        fileIsEmpty: "Il file è vuoto",
        uploadFileTip: "Formato file non supportato",
        unablePreview: "Non aggiunto correttamente alla libreria materiali, anteprima non disponibile",
        confirmDelete: "Confermi l'eliminazione？",
        deleteSuccess: "Eliminazione riuscita",
        delete: "Elimina",
        confirm: "Conferma",
        preview: "Anteprima",
        close: "Chiudi",
        cancel: "Annulla",
        fileType: "Tipo file",
        fileSize: "Dimensione file",
        conversionProgress: "Progresso conversione",
        progress: "Progresso",
        image: "Immagine",
        video: "Video",
        audio: "Musica",
        limitTip01: "Carica",
        limitTip02: "file alla volta",
        okTip: "Caricamento materiale in corso, chiudi più tardi！",
        usableSize: 'Spazio disponibile',
        sizeUnableTip: "Spazio di archiviazione disponibile corrente insufficiente, pulisci i materiali non necessari per risparmiare spazio o contatta il rivenditore per espandere la capacità.",
        view: "Visualizza dettagli",
        fileName: "Nome file",
    },
    template: {
        inputPlaceholder: 'Inserisci',
        selectPlaceholder: 'Seleziona',
        noAuths: "Nessun permesso, contatta l'amministratore",
        operationSuccess: "Operazione riuscita",
        total: "Totale",
        totalNum: "elementi",
        dan: "Singolo",
        shaung: "Doppio",
        pleaseSelectGroup: "Seleziona un gruppo",
        preview: "Anteprima",
        free: "Gratuito",
        use: "Usa",
        dpi: 'Risoluzione',
        delete: "Elimina",
        confirmDelete: "Conferma eliminazione",
        confirmDeleteSelectedTemplate: "Confermi l'eliminazione di questo modello",
        push: "Pubblica",
        pushConfirm: "Confermi la pubblicazione nel modello pubblico",
        pushRemovalConfirm: "Confermi la rimozione dal modello pubblico",
        templateOrderRecord: "Cronologia ordini modelli",
        unpublished: "Non pubblicato",
        auditing: "In revisione",
        publishRejected: "Pubblicazione rifiutata",
        publishSuccess: "Pubblicazione riuscita",
        offShelf: "Disponi fuori catalogo",
        公共模版: "Modello pubblico",
        我的模板: "I miei modelli",
        共享记录: "Cronologia condivisione",
        name: "Nome",
        pubdate: "Data pubblicazione",
        keySeachTip: "Inserisci parola chiave",
        allGroup: "Tutti i gruppi",
        add: "Aggiungi",
        edit: "Modifica",
        programName: "Nome programma",
        selectGroup: "Seleziona gruppo",
    },
    checkManage: {
        total: "Totale",
        totalNum: "elementi",
        operationSuccess: "Operazione riuscita",
        checkUserLogs: "Cronologia revisioni (operatore)",
        checkLogs: "Cronologia revisioni (revisore)",
        sourceCheck: "Revisione materiali",
        programCheck: "Revisione programmi",
        checkAll: "Seleziona tutto",
        auditPass: "Revisione superata",
        auditRefuse: "Revisione rifiutata",
        auditPass01: "Approvato",
        auditRefuse01: "Rifiutato",
        auditRefuse02: "Rifiuta revisione",
        auditor: "Revisore",
        agentUserName: "Autore pubblicazione",
        interrogationTime: "Orario richiesta revisione",
        checkTime: "Orario revisione",
        checkName: "Nome revisione",
        checkType: "Categoria revisione",
        checkIp: "Indirizzo IP richiesta revisione",
        checkReason: "Messaggio",
        checkStatus: "Contenuto operazione",
        rangePicker: "Data revisione",
        keyWord: "Parola chiave",
        all: "Tutti",
        program: 'Programma',
        material: 'Materiale',
        dan: "Singolo",
        shaung: "Doppio",
        pleaseSelectProgram: "Seleziona un programma!",
        pleaseSelectMaterial: "Seleziona un materiale！",
        preview: "Anteprima",
        dpi: 'Risoluzione',
        auditRefuseTip: "Inserisci il motivo del rifiuto",
        unreviewed: "Non revisionato",
        notPassed: "Non approvato",
        notUsed: "Non utilizzato",
        edit: "Modifica",
        none: "Nessuno",
        name: "Nome",
        size: "Dimensione",
        type: "Tipo",
        uploadTime: "Orario caricamento",
        uploadUser: "Utente caricamento",
        checkUser: "Utente revisione",
        image: "Immagine",
        music: "Musica",
        video: "Video",
    },
    systemSet: {
        total: "Totale",
        totalNum: "elementi",
        inputPlaceholder: 'Inserisci',
        selectPlaceholder: 'Seleziona',
        userList: "Membri organizzazione",
        roleList: "Permessi ruoli",
        department: "Struttura organizzativa",
        diskInfo: "Spazio di archiviazione",
        approveSet: "Approvazione contenuti",
        logList: "Gestione log",
        name: "Nome",
        account: "Account",
        userName: "Nome utente",
        phoneNumber: "Numero di telefono",
        role: "Ruolo",
        createTime: "Data di creazione",
        operation: "Operazioni",
        edit: "Modifica",
        delete: "Elimina",
        addNew: "Nuovo",
        add: "Aggiungi",
        resetPassword: "Reimposta password",
        confirmDelete: "Conferma eliminazione",
        departmentOrganization: "Organizzazione reparti",
        addNewUser: "Nuovo utente",
        pleaseEnterUserName: "Inserisci nome utente",
        confirmPasswordNotMatch: "La password di conferma non corrisponde a quella inserita!",
        operationSuccess: "Operazione riuscita！",
        userNickname: "Nome utente",
        pleaseEnterUserNickname: "Inserisci nome utente",
        userNicknameRequired: "Il nome utente non può essere vuoto！",
        password: "Password",
        pleaseEnterPassword: "Inserisci password",
        passwordRequired: "La password non può essere vuota！",
        passwordTip: "La sicurezza della tua password è troppo bassa (la password deve contenere 3 dei seguenti: lettere maiuscole, lettere minuscole, numeri, caratteri speciali e avere una lunghezza compresa tra 8",
        confirmPassword: "Conferma password",
        pleaseEnterPhoneNumber: "Inserisci numero di telefono",
        phoneNumberRequired: "Il numero di telefono non può essere vuoto！",
        phoneNumberFormatError: "Inserisci un formato di numero di telefono corretto！",
        roleRequired: "Il ruolo non può essere vuoto！",
        required: "Non può essere vuoto！",
        departmentName: "Reparto",
        modifyPassword: "Modifica password",
        newPassword: "Nuova password",
        pleaseEnterNewPassword: "Inserisci nuova password",
        pwdMessage: "La password deve essere lunga 8~20 caratteri, non può contenere spazi e deve includere 3 dei seguenti: lettere maiuscole, lettere minuscole, numeri, caratteri speciali",
        all: "Tutti",
        noAuths: "Nessun permesso, contatta l'amministratore",
        departmentName01: "Nome reparto",
        image: "Immagine",
        music: "Musica",
        video: "Video",
        buySize: "Quantità acquistata",
        totalMoney: "Importo pagato",
        buycreateTime: "Data acquisto",
        endTime: "Data scadenza",
        buyTypeStr: "Tipo ordine",
        sourceCheck: "Revisione materiali",
        programCheck: "Revisione programmi",
        programName: "Nome programma",
        diskExpansion: "Si consiglia di pulire regolarmente i materiali scaduti/non utilizzati durante l'uso per garantire la capacità disponibile del sistema. Se hai bisogno di più spazio, puoi contattare il fornitore del dispositivo per ottenere il servizio di espansione della capacità dello spazio di archiviazione cloud. Questo servizio potrebbe generare costi, consulta le informazioni del rivenditore per i dettagli.",
        selectPermission: "Seleziona permessi",
        checkPermission: "Seleziona permessi",
        addRole: "Aggiungi ruolo",
        enterRoleName: "Inserisci nome ruolo",
        roleName: "Nome ruolo",
        roleNameRequired: "Il nome del ruolo non può essere vuoto！",
        remark: "Nota",
        enterRemark: "Inserisci nota",
        permissionSetting: "Impostazioni permessi",
        deleteSuccess: "Eliminazione riuscita！",
        confirmToDelete: "Confermi l'eliminazione？",
        orgName: "Nome organizzazione",
        orgNameRequired: "Il nome dell'organizzazione non può essere vuoto！",
        orgRemark: "Nota organizzazione",
        enterOrgRemark: "Inserisci nota organizzazione",
        capacityUsage: "Utilizzo capacità",
        usedCapacity: "Capacità utilizzata",
        totalCapacity: "Capacità totale",
        remainingCapacity: "Capacità rimanente",
        capacityExpansion: "Espansione capacità",
        enable: "Abilita",
        disable: "Disabilita",
        userName01: "Nome utente",
        loginTime: "Orario accesso",
        ipAddress: "Indirizzo IP",
        loginResult: "Risultato accesso",
        selectDate: "Seleziona data",
        enterDate: "Seleziona una data",
        selectStartTime: "Seleziona orario inizio",
        selectEndTime: "Seleziona orario fine",
        enterUserName: "Inserisci nome utente",
        userCount: "Numero utenti",
        roleDesc: "Descrizione ruolo",
        roleAuthorization: "Autorizzazione ruolo",
        success: "Riuscito",
        failure: "Fallito",
        time: "Orario",
        operationContent: "Contenuto operazione",
        playCount: "Numero riproduzioni",
        playDuration: "Durata riproduzione",
        selectDevice: "Seleziona dispositivo",
        enterProgramName: "Inserisci nome programma",
        serialNumber: "Numero di serie",
        publishContentName: "Nome contenuto pubblicato",
        playMode: "Modalità riproduzione",
        cyclePlay: "Riproduzione ciclica",
        insertPlay: "Inserimento riproduzione",
        paddingPlay: "Riproduzione di riempimento",
        playDeviceId: "ID dispositivo riproduzione",
        playDeviceName: "Nome dispositivo riproduzione",
        publishTime: "Orario pubblicazione",
        downloadStatus: "Stato download",
        notDownloaded: "Non scaricato",
        downloading: "Download in corso",
        downloadSucceeded: "Download riuscito",
        downloadFailed: "Download fallito",
        enterPublishContentName: "Inserisci nome contenuto pubblicato",
        terminalId: "ID terminale",
        belongOrg: "Organizzazione di appartenenza",
        reportTime: "Orario invio",
        reportIp: "IP invio",
        logInfo: "Informazioni log",
        details: "Dettagli",
        confirmDeletion: "Confermi l'eliminazione？",
        logDetails: "Dettagli log",
        download: "Scarica",
        deptOrg: "Organizzazione reparti",
        query: "Cerca",
        queryByTerminalId: "Cerca per ID terminale",
        batchDeleteLogs: "Eliminazione batch log",
        customTimeDeleteLogs: "Eliminazione log per intervallo di tempo personalizzato",
        selectTimeRangeFirst: "Seleziona prima l'intervallo di tempo",
        deleteAllDeviceLogsIfEmpty: "Se non inserisci l'ID dispositivo, verranno eliminati di default i log di tutti i dispositivi",
        enterDeviceIdToDeleteLogs: "Inserisci l'ID dispositivo per cui eliminare i log",
        confirmDeleteAction: "Conferma eliminazione",
        selectDeleteRangeFirst: "Seleziona prima l'intervallo di eliminazione",
        networkConnectionFailed: "Connessione di rete fallita",
        playLog: "Log riproduzione",
        publishLog: "Log pubblicazione",
        errorLog: "Log errori",
        operationLog: "Log operazioni",
        fileLog: "Log file",
        userOperateLog: "Log accessi",
    },
    userManual: {
        userManual: "Manuale utente",
        noData: "Nessun dato",
    },
    systemNotice: {
        systemNotice: "Notifiche sistema",
        noData: "Nessun dato",
        total: "Totale",
        totalNum: "elementi",
        "markAllRead": "Tutto letto",
        "deleteAll": "Elimina tutto",
        "all": "Tutti",
        "unread": "Non letto",
        "read": "Letto",
        "type": "Tipo",
        "content": "Contenuto",
        "date": "Data",
        "status": "Stato",
        "confirmDelete": "Confermi l'eliminazione？",
        "confirm": "Conferma",
        "cancel": "Annulla",
        "delete": "Elimina"
    }
};